import type {
  TReferral,
  TReferralCreatePayload,
  TReferralSearchFilters,
} from "@/api/models/referral/referral";
import ReferralService from "@/api/models/referral/referral";
import {
  createQueryKeys,
  useGenericPaginatedQuery,
  type TOwnedFilterParams,
} from "@/composables/shared/queries";
import { useGenericMutation } from "@/composables/shared/mutations/useGenericMutation";

export const ReferralQueryKeys = createQueryKeys(ReferralService.queryKey, (key) => ({
  paginated: key<TReferralSearchFilters>("paginated"),
}));

export const useCreateReferral = () =>
  useGenericMutation<TReferral, TReferralCreatePayload>({
    mutationFn: (data) => ReferralService.create({}, data),
  });

export const useAcceptReferral = () =>
  useGenericMutation<TReferral, { id: string }>({
    mutationFn: ({ id }) => ReferralService.acceptReferral({ id }, {}),
  });

export const useRejectReferral = () =>
  useGenericMutation<TReferral, { id: string }>({
    mutationFn: ({ id }) => ReferralService.rejectReferral({ id }, {}),
  });

export const usePaginatedReferral = (params: TOwnedFilterParams<TReferralSearchFilters> = {}) => {
  return useGenericPaginatedQuery<TReferral, Partial<TReferralSearchFilters>>({
    queryKey: ReferralQueryKeys.paginated(),
    params,
    fetcher: (fetchParams) =>
      ReferralService.getPaginatedFiltered({}, fetchParams.filters, fetchParams.pageParam),
    permission: $permSubjects.REFERRAL__REFERRAL,
  });
};
